import { getDeliveryData } from './utils/utils'
import { displayPrice } from 'utils/strings'
import React from 'react'

interface OrderSummaryProps {
  cart: order.Cart
  discountCode?: order.DiscountCode
  products?: order.CheckPriceProductObject
}

interface GroupCartPositionByTypeInitialValue {
  positions: Record<string, number>
  addons: Record<string, { amount: number, positionId: string }>
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ cart, products, discountCode }) => {
  const { positions, addons } = getAmountOfCartPositionTypes(cart.positions)
  const delivery = getDeliveryData(cart.selected_delivery, products)
  let finalPrice = delivery?.cost && !discountCode?.valid ? Number(delivery.cost) : 0
  let finalDiscount = 0

  const calculateDiscount = (initialPrice: number, amount: number, discounts?: order.CheckPriceDiscounts) => {
    const basePrice = initialPrice * amount
      if (discounts) {
      const highestDiscount = Object.keys(discounts.percentages).at(-1)
      const currentDiscount = (discounts.percentages[amount] || (highestDiscount ? discounts.percentages[Number(highestDiscount)] : { percentage: 100 }))
      const discount = (currentDiscount.percentage / 100)
      const priceWithDiscount = basePrice * discount
      finalDiscount += (basePrice - priceWithDiscount)
      finalPrice += (basePrice - (basePrice - priceWithDiscount))

    } else {
      finalPrice += basePrice
    }
    return {
      summary: basePrice,
      price: initialPrice
    }
  }

  return (
    <div className='order__summary__content'>
      {Object.entries(positions).map(([positionId, positionAmount]) => {
        const discounts = products?.[positionId]?.discounts
        const initialPrice = Number(products?.[positionId]?.order_params?.cost || 0)
        const { summary, price } = calculateDiscount(initialPrice, positionAmount, discounts)
        return <div
          key={positionId}
          className='order__summary__content__element'>
          <span>{products?.[positionId]?.product_name}</span>
          <span>{positionAmount > 1 ? `${positionAmount} x ${displayPrice(price)} = ` : ''}{displayPrice(summary)}</span>
        </div>
      })}
      {Object.entries(addons).map(([addonId, { amount, positionId }]) => {
        const addon = products?.[positionId]?.order_params?.addons?.find(addon => addon.id === addonId)
        const initialPrice = Number(addon?.cost || 0)
        const { summary, price } = calculateDiscount(initialPrice, amount, addon?.discounts)
        return <div
          key={addonId}
          className='order__summary__content__element'>
          <span>{addon?.name}</span>
          <span>{amount > 1 ? `${amount} x ${displayPrice(price)} = ` : ''}{displayPrice(summary)}</span>
        </div>
      })}
      {finalDiscount > 0 && <div className='order__summary__content__element'>
        <span>Rabat</span>
        <span>{displayPrice(-finalDiscount)}</span>
      </div>}
      {discountCode?.valid && <div className='order__summary__content__element'>
        <span>Kod {discountCode.name} (-{100 - discountCode.percentage}%)</span>
        <span>{(() => {
          const deliveryCost = Number(delivery?.cost)
          const finalPriceBeforeDiscount = discountCode.affects_delivery && deliveryCost ? finalPrice + deliveryCost : finalPrice
          const finalPriceWithDiscount = finalPriceBeforeDiscount - (finalPriceBeforeDiscount * ((100 - discountCode.percentage) / 100))
          const discount = finalPriceBeforeDiscount - finalPriceWithDiscount
          finalPrice = finalPriceWithDiscount
          if (!discountCode.affects_delivery && deliveryCost) {
            finalPrice += deliveryCost
          }
          return displayPrice(-discount)
        })()}</span>
      </div>}
      {delivery && <div className='order__summary__content__element'>
        <span>Dostawa</span>
        <span>{displayPrice(delivery.cost)}</span>
      </div>}
      <div className='order__summary__content__sum'>
        <span>Suma</span>
        <span>{displayPrice(finalPrice)}</span>
      </div>
    </div>
  )
}

const getAmountOfCartPositionTypes = (positions: order.Position[]) => {
  return positions.reduce((r, { id, amount, addons }) => {
    r.positions[id] = (r.positions[id] || 0) + amount
    Object.entries(addons).forEach(([addonId, addonAmount]) => {
      r.addons[addonId] = { amount: (r.addons[addonId]?.amount || 0) + addonAmount, positionId: id }
    })
    return r
  }, { positions: {}, addons: {} } as GroupCartPositionByTypeInitialValue)
}

export default OrderSummary